import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import keycloakConfig from "../../config/keycloakConfig.json";


@Injectable({
    providedIn: 'root'
})
export class SiKeycloakConfigService {

    private config: any;
    constructor(private http: HttpClient) {}

    private getEnvironmentName(): Observable<string> {
        return this.http.get<{ environment: string }>('si/service/auth/keycloak/env').pipe(
            switchMap(response => of(response.environment)),
            catchError(() => of('dev'))  // Fallback to default config if error occurs
        );
    }

    private loadConfigFile(envName: string): Observable<any> {
        return of(keycloakConfig[envName]);
    }

    public loadConfig(): Observable<void> {
        return this.getEnvironmentName().pipe(
            switchMap(envName => this.loadConfigFile(envName)),
            switchMap(config => { this.config = config; return of<void>(undefined); }),
            catchError(() =>  of<void>(undefined))  // Handle errors
        );
    }

    public getConfigByKey(key: string): string {
        return this.config ? this.config[key] : '';
    }
}